// ════════════════════════════════════════════════════════════════════════
//  Woran sich die Führung abhaken lässt
//
//  Aus DERSELBEN Abfrage, die die Klassenliste ohnehin macht: `useClasses`
//  liefert `codeCount` mit, und beide teilen sich den Cache-Schlüssel. Die
//  Führung kostet damit auf keiner Seite eine zusätzliche Anfrage - und auf
//  /classes gar nichts.
//
//  Eine eigene Zählabfrage wäre der naheliegende Weg gewesen und der falsche:
//  sie liefe auf jeder Seite mit, um eine Frage zu beantworten, deren Antwort
//  schon im Cache liegt.
// ════════════════════════════════════════════════════════════════════════

import type { TourFacts } from "./tour.js";

/** Was die Führung aus der Klassenliste über die Lehrkraft erfährt. */
export type ClassFact = {
  readonly id: string;
  readonly codeCount: number;
};

/**
 * Die Klasse, auf die die Führung zeigt, ist die erste OHNE Codes – sonst die
 * erste überhaupt.
 *
 * Grund: Station 2 will dorthin, wo noch etwas zu tun ist. Wer im September
 * eine zweite Klasse anlegt und die Führung noch einmal aufruft, soll nicht auf
 * die fertige 3a geschickt werden, in der schon alles gedruckt ist.
 */
export function factsFrom(classes: readonly ClassFact[] | undefined): TourFacts {
  const list = classes ?? [];
  const ziel = list.find((klasse) => klasse.codeCount === 0) ?? list[0] ?? null;
  return {
    hasClass: list.length > 0,
    hasCodes: list.some((klasse) => klasse.codeCount > 0),
    classId: ziel?.id ?? null,
  };
}
